
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/renters",
      function () {
        return require("private-next-pages/fr/renters.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/renters"])
      });
    }
  